module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-26.24c1ab84.png";